webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _app = __webpack_require__(1);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_app2.default.update(function (state) {
	  return state;
	});

/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(159);
	
	var _flumpt = __webpack_require__(160);
	
	var _cutStore = __webpack_require__(162);
	
	var _cutStore2 = _interopRequireDefault(_cutStore);
	
	var _result = __webpack_require__(164);
	
	var _result2 = _interopRequireDefault(_result);
	
	var _sizeInputs = __webpack_require__(171);
	
	var _sizeInputs2 = _interopRequireDefault(_sizeInputs);
	
	var _csv = __webpack_require__(228);
	
	var _csv2 = _interopRequireDefault(_csv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = (function (_Component) {
	  _inherits(Tabs, _Component);
	
	  function Tabs() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tabs)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.open = function (kind) {
	      return function () {
	        _this.dispatch('tabs:open', kind);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tabs, [{
	    key: 'render',
	    value: function render() {
	      var state = this.props.state;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: 'tabs', 'data-ks-tabs': true },
	          _react2.default.createElement(
	            'li',
	            { className: 'open tab-input-tab' },
	            _react2.default.createElement(
	              'a',
	              { href: '#tab-input', onClick: this.open('input') },
	              '入力'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'tab-csv-tab' },
	            _react2.default.createElement(
	              'a',
	              { href: '#tab-csv', onClick: this.open('csv') },
	              'インポート/エクスポート'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'tab-result-tab' },
	            _react2.default.createElement(
	              'a',
	              { href: '#tab-result', onClick: this.open('result') },
	              '計算結果'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tab_pane_container' },
	          _react2.default.createElement(
	            'article',
	            { id: 'tab-input' },
	            _react2.default.createElement(_sizeInputs2.default, state)
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'tab-csv' },
	            _react2.default.createElement(_csv2.default, state)
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'tab-result' },
	            _react2.default.createElement(_result2.default, state)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tabs;
	})(_flumpt.Component);
	
	var App = (function (_Flux) {
	  _inherits(App, _Flux);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(App).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render(state) {
	      return _react2.default.createElement(Tabs, { state: state });
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe() {
	      var _this3 = this;
	
	      this.on('tabs:open', function (kind) {
	        _this3.update(function (state) {
	          return _extends({}, state, {
	            tab: kind
	          });
	        });
	      });
	      this.on('input:label:change', function (il) {
	        _this3.update(function (state) {
	          state.store.updateLabelOf(il.id, il.label);
	          return state;
	        });
	      });
	      this.on('input:size:change', function (is) {
	        _this3.update(function (state) {
	          state.store.updateSizeOf(is.id, is.size);
	          return state;
	        });
	      });
	      this.on('input:color:change', function (ic) {
	        _this3.update(function (state) {
	          state.store.updateColorOf(ic.id, ic.color);
	          return state;
	        });
	      });
	      this.on('input:copy', function (id) {
	        _this3.update(function (state) {
	          state.store.copy(id);
	          return state;
	        });
	      });
	      this.on('input:remove', function (id) {
	        _this3.update(function (state) {
	          state.store.remove(id);
	          return state;
	        });
	      });
	      this.on('inputs:add', function (num) {
	        _this3.update(function (state) {
	          state.store.addDefault(num);
	          return state;
	        });
	      });
	      this.on('inputs:import', function (data) {
	        _this3.update(function (state) {
	          state.store.import(data);
	          return _extends({}, state, {
	            importing: true
	          });
	        });
	      });
	      this.on('inputs:import:done', function () {
	        _this3.update(function (state) {
	          return _extends({}, state, {
	            importing: false
	          });
	        });
	      });
	    }
	  }]);
	
	  return App;
	})(_flumpt.Flux);
	
	exports.default = new App({
	  renderer: function renderer(el) {
	    (0, _reactDom.render)(el, document.getElementById('app'));
	  },
	  initialState: {
	    store: new _cutStore2.default(),
	    tab: 'input',
	    importing: false
	  },
	  middlewares: []
	});

/***/ },

/***/ 162:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(163);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var initialCut = function initialCut(id) {
	  return {
	    label: '支柱' + id,
	    size: _constants.lumberSize,
	    color: {
	      r: 240,
	      g: 225,
	      b: 170,
	      a: 1
	    }
	  };
	};
	
	var CutStore = (function () {
	  function CutStore() {
	    _classCallCheck(this, CutStore);
	
	    this.cuts = []; // cuts: Array[Cut]
	    this.nextId = 1; // 1 origin for high-school students :)
	  }
	
	  _createClass(CutStore, [{
	    key: 'updateLabelOf',
	    value: function updateLabelOf(id, label) {
	      this.cuts[id].label = label;
	    }
	  }, {
	    key: 'updateSizeOf',
	    value: function updateSizeOf(id, size) {
	      this.cuts[id].size = size;
	    }
	  }, {
	    key: 'updateColorOf',
	    value: function updateColorOf(id, color) {
	      this.cuts[id].color = color;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id) {
	      delete this.cuts[id];
	    }
	  }, {
	    key: 'addDefault',
	    value: function addDefault(num) {
	      if (typeof num === 'undefined') {
	        this.add(initialCut(this.nextId));
	      } else {
	        for (var i = 0; i < num; i++) {
	          this.add(initialCut(this.nextId));
	        }
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add(cut) {
	      this.cuts[this.nextId] = cut;
	      this.nextId = this.nextId + 1;
	    }
	  }, {
	    key: 'copy',
	    value: function copy(id) {
	      var cut = this.cuts[id];
	      if (typeof cut !== 'undefined') {
	        this.add(_extends({}, cut));
	      }
	    }
	  }, {
	    key: 'all',
	    value: function all() {
	      return this.cuts.map(function (cut, id) {
	        return _extends({
	          id: id
	        }, cut);
	      });
	    }
	  }, {
	    key: 'import',
	    value: function _import(data) {
	      var _this = this;
	
	      this.cuts = [];
	      data.forEach(function (cut) {
	        _this.add(cut);
	      });
	    }
	  }]);
	
	  return CutStore;
	})();
	
	exports.default = CutStore;

/***/ },

/***/ 163:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var lumberSize = exports.lumberSize = 3650;

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _flumpt = __webpack_require__(160);
	
	var _color = __webpack_require__(165);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _calc = __webpack_require__(170);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _constants = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lumber = (function (_Component) {
	  _inherits(Lumber, _Component);
	
	  function Lumber() {
	    _classCallCheck(this, Lumber);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Lumber).apply(this, arguments));
	  }
	
	  _createClass(Lumber, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var rest = _props.rest;
	      var cuts = _props.cuts;
	
	      var cutStyles = function cutStyles(cut, color) {
	        var _cut$color = cut.color;
	        var r = _cut$color.r;
	        var g = _cut$color.g;
	        var b = _cut$color.b;
	        var a = _cut$color.a;
	
	        var bc = Math.floor(color.luminosity() * 200);
	        return {
	          width: cut.size / _constants.lumberSize * 100 + '%',
	          backgroundColor: 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')',
	          borderColor: 'rgb(' + bc + ',' + bc + ',' + bc + ')'
	        };
	      };
	      var cutSizeStyles = function cutSizeStyles(color) {
	        var l = color.luminosity();
	        var bc = Math.floor(l >= 0.5 ? l * 256 - 128 : 243);
	        return {
	          color: 'rgb(' + bc + ',' + bc + ',' + bc + ')'
	        };
	      };
	      var cutColorStyle = function cutColorStyle(color) {
	        return {
	          backgroundColor: 'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + color.a + ')'
	        };
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'lumber-wrapper' },
	        _react2.default.createElement(
	          'p',
	          { className: 'lumber-info' },
	          cuts.map(function (cut, i) {
	            return _react2.default.createElement(
	              'span',
	              { key: i, className: 'cut' },
	              _react2.default.createElement('span', { style: cutColorStyle(cut.color), className: 'cut-color' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'cut-label' },
	                cut.label
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cut-size' },
	                cut.size
	              )
	            );
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'lumber-rest' },
	            '残り',
	            rest,
	            'mm'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'lumber' },
	          cuts.map(function (cut, i) {
	            var color = (0, _color2.default)(cut.color);
	            return _react2.default.createElement(
	              'div',
	              { key: i, style: cutStyles(cut, color), className: 'cut' },
	              _react2.default.createElement(
	                'span',
	                { style: cutSizeStyles(color), className: 'cut-size' },
	                cut.size,
	                'mm'
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Lumber;
	})(_flumpt.Component);
	
	var Result = (function (_Component2) {
	  _inherits(Result, _Component2);
	
	  function Result() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, Result);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Result)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this2), _this2.render = function () {
	      var store = _this2.props.store;
	
	      var lumbers = (0, _calc2.default)(store.all());
	      return _react2.default.createElement(
	        'ol',
	        { className: 'result' },
	        lumbers.map(function (lumber, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i },
	            _react2.default.createElement(Lumber, lumber)
	          );
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(Result, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.tab === 'result';
	    }
	  }]);
	
	  return Result;
	})(_flumpt.Component);
	
	exports.default = Result;

/***/ },

/***/ 170:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (cuts) {
	  // stable sort by descending order
	  cuts.sort(function (a, b) {
	    var ord = b.size - a.size;
	    if (ord === 0) {
	      return a.id - b.id;
	    } else {
	      return ord;
	    }
	  });
	  var lumbers = [];
	  cuts.forEach(function (cut) {
	    var index = lumbers.findIndex(function (a) {
	      return a.rest >= cut.size;
	    });
	    if (index >= 0) {
	      // found
	      addCut(lumbers[index], cut);
	    } else {
	      // not found
	      lumbers.push(initial(cut));
	    }
	  });
	  return lumbers;
	};
	
	var _constants = __webpack_require__(163);
	
	var initial = function initial(cut) {
	  return {
	    rest: _constants.lumberSize - cut.size,
	    cuts: [cut]
	  };
	};
	
	var addCut = function addCut(lumber, cut) {
	  lumber.rest = lumber.rest - cut.size;
	  lumber.cuts.push(cut);
	};
	
	// : Array[{ id: number, label: string, size: number, ...rest }] ->
	//   Array[{ rest: number, cuts: Array[{ id: number, label: string, size: number, ...rest }]}]

/***/ },

/***/ 171:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _flumpt = __webpack_require__(160);
	
	var _reactColor = __webpack_require__(172);
	
	var _reactColor2 = _interopRequireDefault(_reactColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SizeInput = (function (_Component) {
	  _inherits(SizeInput, _Component);
	
	  function SizeInput() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SizeInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SizeInput)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      displayColorPicker: false
	    }, _this.onLabelChange = function (e) {
	      _this.dispatch('input:label:change', { id: _this.props.id, label: e.target.value });
	    }, _this.onSizeChange = function (e) {
	      _this.dispatch('input:size:change', { id: _this.props.id, size: e.target.value });
	    }, _this.onColorChange = function (color) {
	      _this.onCloseColorPicker();
	      _this.dispatch('input:color:change', { id: _this.props.id, color: color.rgb });
	    }, _this.openColorPicker = function () {
	      _this.setState({ displayColorPicker: true });
	    }, _this.onCloseColorPicker = function () {
	      _this.setState({ displayColorPicker: false });
	    }, _this.copy = function () {
	      _this.dispatch('input:copy', _this.props.id);
	    }, _this.remove = function () {
	      _this.dispatch('input:remove', _this.props.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SizeInput, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return nextProps.label !== this.props.label || nextProps.size !== this.props.size || JSON.stringify(nextProps.color) !== JSON.stringify(this.props.color) || nextState.displayColorPicker !== this.state.displayColorPicker;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var label = _props.label;
	      var size = _props.size;
	      var color = _props.color;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'size-input form_group form_group-horizontal' },
	        _react2.default.createElement('div', { style: { backgroundColor: 'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + color.a + ')' }, className: 'color', onClick: this.openColorPicker }),
	        this.state.displayColorPicker && _react2.default.createElement(_reactColor2.default, { display: this.state.displayColorPicker,
	          onChangeComplete: this.onColorChange,
	          onClose: this.onCloseColorPicker,
	          color: color,
	          className: 'color-picker',
	          positionCSS: {
	            position: 'absolute',
	            top: '50px',
	            left: '0'
	          },
	          type: 'swatches' }),
	        _react2.default.createElement(
	          'label',
	          null,
	          '名前'
	        ),
	        _react2.default.createElement('input', { type: 'text', value: label, onChange: this.onLabelChange }),
	        _react2.default.createElement(
	          'label',
	          null,
	          '長さ(mm)'
	        ),
	        _react2.default.createElement('input', { type: 'number', value: size, min: 10, max: 3650, onChange: this.onSizeChange }),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.copy },
	          'コピー'
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.remove },
	          'x'
	        )
	      );
	    }
	  }]);
	
	  return SizeInput;
	})(_flumpt.Component);
	
	var SizeInputs = (function (_Component2) {
	  _inherits(SizeInputs, _Component2);
	
	  function SizeInputs() {
	    var _Object$getPrototypeO2;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, SizeInputs);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_Object$getPrototypeO2 = Object.getPrototypeOf(SizeInputs)).call.apply(_Object$getPrototypeO2, [this].concat(args))), _this2), _this2.state = {
	      num: 1
	    }, _this2.handleNum = function (ev) {
	      _this2.setState({ num: ev.target.value });
	    }, _this2.addInput = function () {
	      _this2.dispatch('inputs:add', _this2.state.num);
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(SizeInputs, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.tab === 'input' || nextProps.importing;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.importing && this.props.importing) {
	        window.k$.status({
	          text: 'インポートが完了しました',
	          type: 'status-green'
	        });
	        this.dispatch('inputs:import:done');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.store.all().map(function (cut) {
	          return _react2.default.createElement(SizeInput, _extends({ key: cut.id }, cut));
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'form_group form_group-horizontal' },
	          _react2.default.createElement('input', { type: 'number', value: this.state.num, min: 1, max: 200, onChange: this.handleNum }),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.addInput },
	            '追加'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SizeInputs;
	})(_flumpt.Component);
	
	exports.default = SizeInputs;

/***/ },

/***/ 228:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _flumpt = __webpack_require__(160);
	
	var _csvParse = __webpack_require__(229);
	
	var _csvParse2 = _interopRequireDefault(_csvParse);
	
	var _csvStringify = __webpack_require__(252);
	
	var _csvStringify2 = _interopRequireDefault(_csvStringify);
	
	var _constants = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Csv = (function (_Component) {
	  _inherits(Csv, _Component);
	
	  function Csv() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Csv);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Csv)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.read = function () {
	      var text = document.getElementById('csv-import-area').value;
	      var options = {
	        columns: true
	      };
	      (0, _csvParse2.default)(text, options, function (err, data) {
	        if (err) {
	          console.error(err); // eslint-disable-line no-console
	        } else {
	            _this.dispatch('inputs:import', data.map(function (cut, id) {
	              return {
	                label: cut.label || '支柱' + id,
	                size: cut.size || _constants.lumberSize,
	                color: {
	                  r: (cut.r || 240) * 1,
	                  g: (cut.g || 225) * 1,
	                  b: (cut.b || 170) * 1,
	                  a: (cut.a || 1) * 1
	                }
	              };
	            }));
	          }
	      });
	    }, _this.componentWillUpdate = function (nextProps) {
	      var store = nextProps.store;
	
	      var data = store.all().map(function (cut) {
	        return {
	          label: cut.label,
	          size: cut.size,
	          r: cut.color.r,
	          g: cut.color.g,
	          b: cut.color.b,
	          a: cut.color.a
	        };
	      });
	      var options = {
	        header: true
	      };
	      (0, _csvStringify2.default)(data, options, function (err, out) {
	        if (err) {
	          console.error(err); // eslint-disable-line no-console
	        } else {
	            document.getElementById('csv-export-area').value = out;
	          }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Csv, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.tab === 'csv';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'csv-area-wrapper' },
	          _react2.default.createElement(
	            'p',
	            null,
	            '保存したデータを貼り付けて読み込むことができます。データ形式はCSVです (Excelなどで作成する場合はヘッダーを label, size, r, g, b, a としてください)。'
	          ),
	          _react2.default.createElement('textarea', { id: 'csv-import-area', className: 'csv-area' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'csv-buttons' },
	            _react2.default.createElement(
	              'button',
	              { 'data-ks-tooltip': 'データを読み込み、現在のデータを上書きします',
	                'data-ks-tooltip-position': 'bottom',
	                onClick: this.read },
	              '読み込む'
	            )
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'csv-area-wrapper' },
	          _react2.default.createElement(
	            'p',
	            null,
	            '現在の入力データです。コピーして保存してください。'
	          ),
	          _react2.default.createElement('textarea', { id: 'csv-export-area', className: 'csv-area', readOnly: true })
	        )
	      );
	    }
	  }]);
	
	  return Csv;
	})(_flumpt.Component);
	
	exports.default = Csv;

/***/ }

});


/** WEBPACK FOOTER **
 ** bundle.js
 **/